import { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import Chrome from "./components/Chrome";
import CommandPalette from "./components/CommandPalette";
import Login from "./screens/Login";
import Home from "./screens/Home";
import Repository from "./screens/Repository";
import Dashboards from "./screens/Dashboards";
import Ask from "./screens/Ask";
import Investigate from "./screens/Investigate";
import Signal from "./screens/Signal";
import Settings from "./screens/Settings";
import QuoteExplorer from "./screens/QuoteExplorer";
import Drivers from "./screens/Drivers";
import CromptonLens from "./screens/CromptonLens";
import Connections from "./screens/Connections";

export default function App() {
  const [authed, setAuthed] = useState(false);
  const [cmdk, setCmdk] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();

  // keyboard shortcut for command palette
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setCmdk((v) => !v);
      }
      if (e.key === "Escape") setCmdk(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // gate everything behind login except /login
  useEffect(() => {
    if (!authed && loc.pathname !== "/login") {
      nav("/login", { replace: true });
    }
  }, [authed, loc.pathname, nav]);

  if (!authed) {
    return (
      <Routes>
        <Route path="/login" element={<Login onSignIn={() => { setAuthed(true); nav("/", { replace: true }); }} />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <>
      <Chrome onOpenCmdk={() => setCmdk(true)}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/repository" element={<Repository />} />
          <Route path="/dashboards" element={<Dashboards />} />
          <Route path="/ask" element={<Ask />} />
          <Route path="/investigate" element={<Investigate />} />
          <Route path="/signal" element={<Signal />} />
          <Route path="/quotes" element={<QuoteExplorer />} />
          <Route path="/drivers" element={<Drivers />} />
          <Route path="/crompton" element={<CromptonLens />} />
          <Route path="/connections" element={<Connections />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Chrome>
      {cmdk && <CommandPalette onClose={() => setCmdk(false)} />}
    </>
  );
}
